import watchSpawnNotification from './watchSpawnNotification';

export default [watchSpawnNotification];
